import { render, staticRenderFns } from "./VxInputGroup.vue?vue&type=template&id=769852af&functional=true"
import script from "./VxInputGroup.vue?vue&type=script&lang=js"
export * from "./VxInputGroup.vue?vue&type=script&lang=js"
import style0 from "./VxInputGroup.vue?vue&type=style&index=0&id=769852af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports